export default () => {
	return (
		<svg
			version="1.1"
			style={{ display: 'none' }}
			xmlns="http://www.w3.org/2000/svg"
		>
			<symbol id="horizon-dark" viewBox="0 0 832 126">
				<path
					strokeWidth="0"
					d="M420.371,124.885c-1.352,-0.744 -2.407,-1.763 -3.167,-3.06c-0.76,-1.295 -1.14,-2.751 -1.14,-4.368c-0,-1.615 0.38,-3.07 1.14,-4.366c0.76,-1.296 1.815,-2.315 3.167,-3.059c1.351,-0.744 2.859,-1.117 4.523,-1.117c1.663,0 3.163,0.368 4.499,1.105c1.336,0.735 2.388,1.756 3.156,3.059c0.768,1.304 1.151,2.763 1.151,4.378c0,1.617 -0.383,3.076 -1.151,4.38c-0.768,1.304 -1.82,2.324 -3.156,3.061c-1.336,0.735 -2.836,1.102 -4.499,1.102c-1.664,-0 -3.172,-0.372 -4.523,-1.115Zm-64.451,-0c-1.353,-0.744 -2.408,-1.763 -3.168,-3.06c-0.76,-1.295 -1.139,-2.751 -1.139,-4.368c0,-1.615 0.379,-3.07 1.139,-4.366c0.76,-1.296 1.815,-2.315 3.168,-3.059c1.351,-0.744 2.859,-1.117 4.523,-1.117c1.663,0 3.163,0.368 4.499,1.105c1.336,0.735 2.387,1.756 3.155,3.059c0.768,1.304 1.152,2.763 1.152,4.378c-0,1.617 -0.384,3.076 -1.152,4.38c-0.768,1.304 -1.819,2.324 -3.155,3.061c-1.336,0.735 -2.836,1.102 -4.499,1.102c-1.664,-0 -3.172,-0.372 -4.523,-1.115Zm-54.746,-0.756c-1.217,-1.248 -1.824,-3.063 -1.824,-5.447l0,-9.622l1.775,-0l-0,9.55c-0,1.952 0.44,3.407 1.32,4.368c0.88,0.959 2.152,1.439 3.816,1.439c1.679,0 2.959,-0.48 3.839,-1.439c0.88,-0.961 1.32,-2.416 1.32,-4.368l0,-9.55l1.727,-0l0,9.622c0,2.384 -0.604,4.199 -1.811,5.447c-1.208,1.247 -2.9,1.871 -5.075,1.871c-2.176,-0 -3.872,-0.624 -5.087,-1.871Zm100.205,-15.069l-0,16.797l-1.704,-0l-0,-13.438l-6.599,11.302l-0.839,-0l-6.599,-11.23l0,13.366l-1.704,-0l-0,-16.797l1.464,-0l7.294,12.454l7.223,-12.454l1.464,-0Zm71.242,-0l1.776,-0l0,16.797l-1.776,-0l0,-16.797Zm56.725,15.262l0,1.535l-11.877,-0l-0,-16.797l11.517,-0l0,1.535l-9.742,0l0,5.976l8.686,0l-0,1.511l-8.686,-0l0,6.24l10.102,0Zm-197.218,-13.727l-5.903,0l0,-1.535l13.581,-0l-0,1.535l-5.902,0l-0,15.262l-1.776,-0l-0,-15.262Zm119.281,0l-5.902,0l-0,-1.535l13.581,-0l0,1.535l-5.904,0l-0,15.262l-1.775,-0l-0,-15.262Zm52.935,-1.535l-7.439,16.797l-1.752,-0l-7.438,-16.797l1.92,-0l6.43,14.59l6.479,-14.59l1.8,-0Zm-221.863,12.309l-9.358,-0l-2.016,4.488l-1.847,-0l7.678,-16.797l1.752,-0l7.678,16.797l-1.871,-0l-2.016,-4.488Zm146.013,2.148c1.071,-0.6 1.911,-1.431 2.518,-2.495c0.609,-1.064 0.913,-2.252 0.913,-3.565c-0,-1.31 -0.304,-2.499 -0.913,-3.562c-0.607,-1.064 -1.447,-1.896 -2.518,-2.496c-1.072,-0.6 -2.273,-0.9 -3.6,-0.9c-1.328,-0 -2.532,0.3 -3.611,0.9c-1.08,0.6 -1.928,1.432 -2.544,2.496c-0.615,1.063 -0.924,2.252 -0.924,3.562c0,1.313 0.309,2.501 0.924,3.565c0.616,1.064 1.464,1.895 2.544,2.495c1.079,0.6 2.283,0.9 3.611,0.9c1.327,0 2.528,-0.3 3.6,-0.9Zm-64.452,-0c1.072,-0.6 1.911,-1.431 2.519,-2.495c0.608,-1.064 0.912,-2.252 0.912,-3.565c-0,-1.31 -0.304,-2.499 -0.912,-3.562c-0.608,-1.064 -1.447,-1.896 -2.519,-2.496c-1.072,-0.6 -2.272,-0.9 -3.599,-0.9c-1.328,-0 -2.532,0.3 -3.612,0.9c-1.08,0.6 -1.928,1.432 -2.544,2.496c-0.615,1.063 -0.923,2.252 -0.923,3.562c0,1.313 0.308,2.501 0.923,3.565c0.616,1.064 1.464,1.895 2.544,2.495c1.08,0.6 2.284,0.9 3.612,0.9c1.327,0 2.527,-0.3 3.599,-0.9Zm-82.209,-3.587l-4.031,-9.022l-4.031,9.022l8.062,-0Zm370.482,-115.775c-6.064,-3.339 -12.959,-5.032 -20.489,-5.032c-7.535,0 -14.464,1.711 -20.594,5.085c-6.143,3.38 -11.011,8.081 -14.464,13.973c-3.455,5.89 -5.205,12.594 -5.205,19.924c-0,7.33 1.75,14.032 5.205,19.923c3.455,5.892 8.321,10.593 14.464,13.972c6.13,3.374 13.059,5.086 20.594,5.086c7.536,-0 14.429,-1.693 20.489,-5.032c6.07,-3.344 10.918,-8.045 14.407,-13.97c3.49,-5.925 5.26,-12.647 5.26,-19.979c-0,-7.33 -1.77,-14.052 -5.26,-19.978c-3.487,-5.922 -8.335,-10.623 -14.407,-13.972Zm-464.939,-0c-6.064,-3.339 -12.958,-5.032 -20.489,-5.032c-7.535,0 -14.464,1.711 -20.593,5.085c-6.144,3.38 -11.01,8.081 -14.464,13.973c-3.454,5.89 -5.205,12.594 -5.205,19.924c-0,7.33 1.751,14.032 5.205,19.923c3.454,5.892 8.321,10.593 14.464,13.972c6.129,3.374 13.057,5.086 20.593,5.086c7.537,-0 14.43,-1.693 20.489,-5.032c6.07,-3.342 10.918,-8.043 14.407,-13.97c3.49,-5.925 5.26,-12.647 5.26,-19.979c-0,-7.33 -1.77,-14.052 -5.26,-19.978c-3.487,-5.923 -8.335,-10.624 -14.407,-13.972Zm639.688,59.041c1.077,0.615 1.924,1.462 2.54,2.539c0.615,1.078 0.923,2.273 0.923,3.584c-0,1.312 -0.314,2.513 -0.943,3.604c-0.629,1.09 -1.486,1.95 -2.57,2.579c-1.084,0.63 -2.282,0.943 -3.593,0.943c-1.312,-0 -2.506,-0.313 -3.583,-0.943c-1.078,-0.629 -1.928,-1.486 -2.55,-2.57c-0.622,-1.084 -0.934,-2.275 -0.934,-3.573c0,-1.298 0.312,-2.49 0.934,-3.574c0.622,-1.084 1.475,-1.94 2.559,-2.569c1.084,-0.629 2.288,-0.944 3.614,-0.944c1.325,-0 2.526,0.308 3.603,0.924Zm-817.2,-63.433l-9.864,0l-0,76.682l9.864,-0l0,-34.476l44.787,0l0,34.476l9.755,-0l-0,-43.482l-54.542,0.101l0,-33.301Zm384.168,76.682l9.863,-0l-0,-76.682l-9.863,0l0,76.682Zm-68.934,-34.716c3.066,-4.175 4.621,-9.344 4.621,-15.365c-0,-8.232 -2.847,-14.807 -8.462,-19.539c-5.567,-4.686 -13.321,-7.062 -23.048,-7.062l-28.949,0l0,76.682l9.864,-0l-0,-23.694l19.085,-0c1.876,-0 3.726,-0.089 5.509,-0.267l17.039,23.961l11.059,-0l-18.598,-26.099c5.052,-1.864 9.044,-4.758 11.88,-8.617Zm202.755,-34.929l0.213,-0.268l-0,-6.769l-5.973,0l-55.766,69.643l-0.215,0.269l-0,6.77l63.234,-0l0,-8.795l-49.652,0l48.159,-60.85Zm214.616,-6.656l-0.293,-0.381l-7.978,0l-0,76.682l9.865,-0l-0,-58.788l46.28,58.415l0.293,0.373l10.972,-0l-59.139,-76.301Zm84.083,74.576c0.937,-0.549 1.677,-1.299 2.219,-2.25c0.542,-0.95 0.813,-2 0.813,-3.151c-0,-1.151 -0.265,-2.195 -0.793,-3.132c-0.529,-0.937 -1.258,-1.673 -2.189,-2.208c-0.929,-0.535 -1.976,-0.803 -3.141,-0.803c-1.152,-0 -2.199,0.274 -3.142,0.823c-0.943,0.549 -1.684,1.295 -2.219,2.238c-0.535,0.944 -0.802,1.984 -0.802,3.122c-0,1.138 0.267,2.178 0.802,3.121c0.535,0.945 1.272,1.691 2.209,2.24c0.937,0.548 1.974,0.822 3.112,0.822c1.151,-0 2.195,-0.274 3.131,-0.822Zm0.061,-5.1c-0.295,0.429 -0.71,0.736 -1.245,0.924l1.827,2.83l-1.386,0l-1.666,-2.57l-2.188,0l0,2.57l-1.364,0l0,-8.03l3.211,0c1.004,0 1.797,0.248 2.379,0.743c0.582,0.495 0.873,1.157 0.873,1.987c0,0.603 -0.147,1.118 -0.441,1.546Zm-1.416,-0.361c0.355,-0.282 0.532,-0.676 0.532,-1.185c0,-0.509 -0.177,-0.9 -0.532,-1.174c-0.354,-0.274 -0.853,-0.412 -1.495,-0.412l-1.767,-0l-0,3.192l1.767,0c0.642,0 1.141,-0.14 1.495,-0.421Zm-628.019,-31.154c-0,5.637 -1.321,10.806 -3.925,15.362c-2.6,4.551 -6.245,8.163 -10.835,10.732c-4.598,2.572 -9.823,3.876 -15.531,3.876c-5.708,0 -10.952,-1.305 -15.587,-3.878c-4.626,-2.569 -8.306,-6.181 -10.94,-10.736c-2.64,-4.554 -3.977,-9.721 -3.977,-15.356c-0,-5.635 1.337,-10.802 3.977,-15.359c2.635,-4.552 6.316,-8.165 10.94,-10.735c4.635,-2.574 9.879,-3.878 15.587,-3.878c5.708,0 10.933,1.304 15.531,3.876c4.588,2.57 8.233,6.181 10.835,10.732c2.604,4.56 3.925,9.729 3.925,15.364Zm464.939,0c0,5.639 -1.321,10.806 -3.925,15.362c-2.6,4.551 -6.245,8.163 -10.835,10.732c-4.598,2.572 -9.825,3.876 -15.531,3.876c-5.709,0 -10.953,-1.305 -15.586,-3.878c-4.627,-2.569 -8.309,-6.181 -10.942,-10.736c-2.637,-4.552 -3.976,-9.719 -3.976,-15.356c0,-5.635 1.339,-10.803 3.977,-15.359c2.634,-4.553 6.316,-8.165 10.941,-10.735c4.633,-2.574 9.877,-3.878 15.586,-3.878c5.706,0 10.933,1.304 15.531,3.876c4.588,2.57 8.233,6.181 10.835,10.732c2.604,4.558 3.925,9.728 3.925,15.364Zm-382.993,-29.546l18.87,-0c7.13,-0 12.629,1.558 16.346,4.631c3.711,3.073 5.513,7.382 5.513,13.174c-0,5.653 -1.804,9.911 -5.517,13.016c-3.713,3.105 -9.211,4.679 -16.342,4.679l-18.87,-0l-0,-35.5Z"
					stroke="#263854"
					fill="#263854"
				></path>
				<path
					fill="#1FB0E5"
					strokeWidth="0"
					d="M64.397,-0.237l-9.746,0l0,9.747l9.746,0l0,-9.747Zm734.199,0l-9.748,0l0,9.747l9.748,0l0,-9.747Zm-322.941,0l-8.796,0l0,8.796l8.796,-0l-0,-8.796Z"
					stroke="#263854"
				></path>
			</symbol>
			<symbol id="horizon-light" viewBox="0 0 832 126">
				<path
					strokeWidth="0"
					d="M420.371,124.885c-1.352,-0.744 -2.407,-1.763 -3.167,-3.06c-0.76,-1.295 -1.14,-2.751 -1.14,-4.368c-0,-1.615 0.38,-3.07 1.14,-4.366c0.76,-1.296 1.815,-2.315 3.167,-3.059c1.351,-0.744 2.859,-1.117 4.523,-1.117c1.663,0 3.163,0.368 4.499,1.105c1.336,0.735 2.388,1.756 3.156,3.059c0.768,1.304 1.151,2.763 1.151,4.378c0,1.617 -0.383,3.076 -1.151,4.38c-0.768,1.304 -1.82,2.324 -3.156,3.061c-1.336,0.735 -2.836,1.102 -4.499,1.102c-1.664,-0 -3.172,-0.372 -4.523,-1.115Zm-64.451,-0c-1.353,-0.744 -2.408,-1.763 -3.168,-3.06c-0.76,-1.295 -1.139,-2.751 -1.139,-4.368c0,-1.615 0.379,-3.07 1.139,-4.366c0.76,-1.296 1.815,-2.315 3.168,-3.059c1.351,-0.744 2.859,-1.117 4.523,-1.117c1.663,0 3.163,0.368 4.499,1.105c1.336,0.735 2.387,1.756 3.155,3.059c0.768,1.304 1.152,2.763 1.152,4.378c-0,1.617 -0.384,3.076 -1.152,4.38c-0.768,1.304 -1.819,2.324 -3.155,3.061c-1.336,0.735 -2.836,1.102 -4.499,1.102c-1.664,-0 -3.172,-0.372 -4.523,-1.115Zm-54.746,-0.756c-1.217,-1.248 -1.824,-3.063 -1.824,-5.447l0,-9.622l1.775,-0l-0,9.55c-0,1.952 0.44,3.407 1.32,4.368c0.88,0.959 2.152,1.439 3.816,1.439c1.679,0 2.959,-0.48 3.839,-1.439c0.88,-0.961 1.32,-2.416 1.32,-4.368l0,-9.55l1.727,-0l0,9.622c0,2.384 -0.604,4.199 -1.811,5.447c-1.208,1.247 -2.9,1.871 -5.075,1.871c-2.176,-0 -3.872,-0.624 -5.087,-1.871Zm100.205,-15.069l-0,16.797l-1.704,-0l-0,-13.438l-6.599,11.302l-0.839,-0l-6.599,-11.23l0,13.366l-1.704,-0l-0,-16.797l1.464,-0l7.294,12.454l7.223,-12.454l1.464,-0Zm71.242,-0l1.776,-0l0,16.797l-1.776,-0l0,-16.797Zm56.725,15.262l0,1.535l-11.877,-0l-0,-16.797l11.517,-0l0,1.535l-9.742,0l0,5.976l8.686,0l-0,1.511l-8.686,-0l0,6.24l10.102,0Zm-197.218,-13.727l-5.903,0l0,-1.535l13.581,-0l-0,1.535l-5.902,0l-0,15.262l-1.776,-0l-0,-15.262Zm119.281,0l-5.902,0l-0,-1.535l13.581,-0l0,1.535l-5.904,0l-0,15.262l-1.775,-0l-0,-15.262Zm52.935,-1.535l-7.439,16.797l-1.752,-0l-7.438,-16.797l1.92,-0l6.43,14.59l6.479,-14.59l1.8,-0Zm-221.863,12.309l-9.358,-0l-2.016,4.488l-1.847,-0l7.678,-16.797l1.752,-0l7.678,16.797l-1.871,-0l-2.016,-4.488Zm146.013,2.148c1.071,-0.6 1.911,-1.431 2.518,-2.495c0.609,-1.064 0.913,-2.252 0.913,-3.565c-0,-1.31 -0.304,-2.499 -0.913,-3.562c-0.607,-1.064 -1.447,-1.896 -2.518,-2.496c-1.072,-0.6 -2.273,-0.9 -3.6,-0.9c-1.328,-0 -2.532,0.3 -3.611,0.9c-1.08,0.6 -1.928,1.432 -2.544,2.496c-0.615,1.063 -0.924,2.252 -0.924,3.562c0,1.313 0.309,2.501 0.924,3.565c0.616,1.064 1.464,1.895 2.544,2.495c1.079,0.6 2.283,0.9 3.611,0.9c1.327,0 2.528,-0.3 3.6,-0.9Zm-64.452,-0c1.072,-0.6 1.911,-1.431 2.519,-2.495c0.608,-1.064 0.912,-2.252 0.912,-3.565c-0,-1.31 -0.304,-2.499 -0.912,-3.562c-0.608,-1.064 -1.447,-1.896 -2.519,-2.496c-1.072,-0.6 -2.272,-0.9 -3.599,-0.9c-1.328,-0 -2.532,0.3 -3.612,0.9c-1.08,0.6 -1.928,1.432 -2.544,2.496c-0.615,1.063 -0.923,2.252 -0.923,3.562c0,1.313 0.308,2.501 0.923,3.565c0.616,1.064 1.464,1.895 2.544,2.495c1.08,0.6 2.284,0.9 3.612,0.9c1.327,0 2.527,-0.3 3.599,-0.9Zm-82.209,-3.587l-4.031,-9.022l-4.031,9.022l8.062,-0Zm370.482,-115.775c-6.064,-3.339 -12.959,-5.032 -20.489,-5.032c-7.535,0 -14.464,1.711 -20.594,5.085c-6.143,3.38 -11.011,8.081 -14.464,13.973c-3.455,5.89 -5.205,12.594 -5.205,19.924c-0,7.33 1.75,14.032 5.205,19.923c3.455,5.892 8.321,10.593 14.464,13.972c6.13,3.374 13.059,5.086 20.594,5.086c7.536,-0 14.429,-1.693 20.489,-5.032c6.07,-3.344 10.918,-8.045 14.407,-13.97c3.49,-5.925 5.26,-12.647 5.26,-19.979c-0,-7.33 -1.77,-14.052 -5.26,-19.978c-3.487,-5.922 -8.335,-10.623 -14.407,-13.972Zm-464.939,-0c-6.064,-3.339 -12.958,-5.032 -20.489,-5.032c-7.535,0 -14.464,1.711 -20.593,5.085c-6.144,3.38 -11.01,8.081 -14.464,13.973c-3.454,5.89 -5.205,12.594 -5.205,19.924c-0,7.33 1.751,14.032 5.205,19.923c3.454,5.892 8.321,10.593 14.464,13.972c6.129,3.374 13.057,5.086 20.593,5.086c7.537,-0 14.43,-1.693 20.489,-5.032c6.07,-3.342 10.918,-8.043 14.407,-13.97c3.49,-5.925 5.26,-12.647 5.26,-19.979c-0,-7.33 -1.77,-14.052 -5.26,-19.978c-3.487,-5.923 -8.335,-10.624 -14.407,-13.972Zm639.688,59.041c1.077,0.615 1.924,1.462 2.54,2.539c0.615,1.078 0.923,2.273 0.923,3.584c-0,1.312 -0.314,2.513 -0.943,3.604c-0.629,1.09 -1.486,1.95 -2.57,2.579c-1.084,0.63 -2.282,0.943 -3.593,0.943c-1.312,-0 -2.506,-0.313 -3.583,-0.943c-1.078,-0.629 -1.928,-1.486 -2.55,-2.57c-0.622,-1.084 -0.934,-2.275 -0.934,-3.573c0,-1.298 0.312,-2.49 0.934,-3.574c0.622,-1.084 1.475,-1.94 2.559,-2.569c1.084,-0.629 2.288,-0.944 3.614,-0.944c1.325,-0 2.526,0.308 3.603,0.924Zm-817.2,-63.433l-9.864,0l-0,76.682l9.864,-0l0,-34.476l44.787,0l0,34.476l9.755,-0l-0,-43.482l-54.542,0.101l0,-33.301Zm384.168,76.682l9.863,-0l-0,-76.682l-9.863,0l0,76.682Zm-68.934,-34.716c3.066,-4.175 4.621,-9.344 4.621,-15.365c-0,-8.232 -2.847,-14.807 -8.462,-19.539c-5.567,-4.686 -13.321,-7.062 -23.048,-7.062l-28.949,0l0,76.682l9.864,-0l-0,-23.694l19.085,-0c1.876,-0 3.726,-0.089 5.509,-0.267l17.039,23.961l11.059,-0l-18.598,-26.099c5.052,-1.864 9.044,-4.758 11.88,-8.617Zm202.755,-34.929l0.213,-0.268l-0,-6.769l-5.973,0l-55.766,69.643l-0.215,0.269l-0,6.77l63.234,-0l0,-8.795l-49.652,0l48.159,-60.85Zm214.616,-6.656l-0.293,-0.381l-7.978,0l-0,76.682l9.865,-0l-0,-58.788l46.28,58.415l0.293,0.373l10.972,-0l-59.139,-76.301Zm84.083,74.576c0.937,-0.549 1.677,-1.299 2.219,-2.25c0.542,-0.95 0.813,-2 0.813,-3.151c-0,-1.151 -0.265,-2.195 -0.793,-3.132c-0.529,-0.937 -1.258,-1.673 -2.189,-2.208c-0.929,-0.535 -1.976,-0.803 -3.141,-0.803c-1.152,-0 -2.199,0.274 -3.142,0.823c-0.943,0.549 -1.684,1.295 -2.219,2.238c-0.535,0.944 -0.802,1.984 -0.802,3.122c-0,1.138 0.267,2.178 0.802,3.121c0.535,0.945 1.272,1.691 2.209,2.24c0.937,0.548 1.974,0.822 3.112,0.822c1.151,-0 2.195,-0.274 3.131,-0.822Zm0.061,-5.1c-0.295,0.429 -0.71,0.736 -1.245,0.924l1.827,2.83l-1.386,0l-1.666,-2.57l-2.188,0l0,2.57l-1.364,0l0,-8.03l3.211,0c1.004,0 1.797,0.248 2.379,0.743c0.582,0.495 0.873,1.157 0.873,1.987c0,0.603 -0.147,1.118 -0.441,1.546Zm-1.416,-0.361c0.355,-0.282 0.532,-0.676 0.532,-1.185c0,-0.509 -0.177,-0.9 -0.532,-1.174c-0.354,-0.274 -0.853,-0.412 -1.495,-0.412l-1.767,-0l-0,3.192l1.767,0c0.642,0 1.141,-0.14 1.495,-0.421Zm-628.019,-31.154c-0,5.637 -1.321,10.806 -3.925,15.362c-2.6,4.551 -6.245,8.163 -10.835,10.732c-4.598,2.572 -9.823,3.876 -15.531,3.876c-5.708,0 -10.952,-1.305 -15.587,-3.878c-4.626,-2.569 -8.306,-6.181 -10.94,-10.736c-2.64,-4.554 -3.977,-9.721 -3.977,-15.356c-0,-5.635 1.337,-10.802 3.977,-15.359c2.635,-4.552 6.316,-8.165 10.94,-10.735c4.635,-2.574 9.879,-3.878 15.587,-3.878c5.708,0 10.933,1.304 15.531,3.876c4.588,2.57 8.233,6.181 10.835,10.732c2.604,4.56 3.925,9.729 3.925,15.364Zm464.939,0c0,5.639 -1.321,10.806 -3.925,15.362c-2.6,4.551 -6.245,8.163 -10.835,10.732c-4.598,2.572 -9.825,3.876 -15.531,3.876c-5.709,0 -10.953,-1.305 -15.586,-3.878c-4.627,-2.569 -8.309,-6.181 -10.942,-10.736c-2.637,-4.552 -3.976,-9.719 -3.976,-15.356c0,-5.635 1.339,-10.803 3.977,-15.359c2.634,-4.553 6.316,-8.165 10.941,-10.735c4.633,-2.574 9.877,-3.878 15.586,-3.878c5.706,0 10.933,1.304 15.531,3.876c4.588,2.57 8.233,6.181 10.835,10.732c2.604,4.558 3.925,9.728 3.925,15.364Zm-382.993,-29.546l18.87,-0c7.13,-0 12.629,1.558 16.346,4.631c3.711,3.073 5.513,7.382 5.513,13.174c-0,5.653 -1.804,9.911 -5.517,13.016c-3.713,3.105 -9.211,4.679 -16.342,4.679l-18.87,-0l-0,-35.5Z"
					stroke="#F2F2F2"
					fill="#F2F2F2"
				></path>
				<path
					fill="#1FB0E5"
					strokeWidth="0"
					d="M64.397,-0.237l-9.746,0l0,9.747l9.746,0l0,-9.747Zm734.199,0l-9.748,0l0,9.747l9.748,0l0,-9.747Zm-322.941,0l-8.796,0l0,8.796l8.796,-0l-0,-8.796Z"
					stroke="#F2F2F2"
				></path>
			</symbol>
			<symbol id="engine" viewBox="0 0 23 34">
				<path
					strokeWidth="0"
					d="M22.392 19.6403H19.719L15.179 15.1004H0.608032V6.15036H19.926V7.15036H1.60803V14.1004H15.594L20.133 18.6403H21.392V5.05336H0.608032V0.693359H21.892V1.69336H1.60803V4.05336H22.392V19.6403Z"
				></path>
				<path
					strokeWidth="0"
					d="M4.00903 33.805H3.00903V29.844L8.15303 24.7V17.543H5.58403L3.48703 19.64H1.10803V18.64H3.07203L5.16903 16.543H9.15303V25.114L4.00903 30.259V33.805Z"
				></path>
				<path
					strokeWidth="0"
					d="M20.065 33.805H19.065V30.259L14.052 25.245V17.043H15.052V24.831L20.065 29.844V33.805Z"
				></path>
				<path
					strokeWidth="0"
					d="M11.5001 13.0391C10.9969 13.0393 10.505 12.8903 10.0866 12.6108C9.66814 12.3313 9.34204 11.934 9.14953 11.4691C8.95703 11.0042 8.90676 10.4926 9.00509 9.99915C9.10342 9.50568 9.34594 9.05248 9.70195 8.69689C10.058 8.34131 10.5114 8.09933 11.005 8.00158C11.4986 7.90382 12.0101 7.9547 12.4748 8.14775C12.9394 8.34081 13.3364 8.66738 13.6154 9.08612C13.8944 9.50486 14.0429 9.99696 14.0421 10.5001C14.0405 11.1735 13.7721 11.8189 13.2956 12.2948C12.8191 12.7707 12.1735 13.0383 11.5001 13.0391ZM11.5001 8.95413C11.195 8.95393 10.8967 9.04418 10.6429 9.21348C10.389 9.38277 10.1911 9.62351 10.0741 9.90526C9.95706 10.187 9.92618 10.4971 9.98537 10.7964C10.0445 11.0957 10.1911 11.3708 10.4066 11.5868C10.622 11.8028 10.8967 11.9501 11.1958 12.01C11.495 12.07 11.8052 12.0399 12.0872 11.9236C12.3693 11.8073 12.6105 11.61 12.7805 11.3567C12.9504 11.1033 13.0415 10.8052 13.0421 10.5001C13.0423 10.2974 13.0026 10.0965 12.9253 9.90911C12.8479 9.72169 12.7344 9.55133 12.5912 9.40777C12.4481 9.26421 12.278 9.15026 12.0908 9.07242C11.9035 8.99459 11.7028 8.95439 11.5001 8.95413Z"
				></path>
				<path
					strokeWidth="0"
					d="M15.189 33.8062H14.189C14.189 33.093 13.9057 32.4091 13.4014 31.9048C12.8971 31.4005 12.2132 31.1172 11.5 31.1172C10.7869 31.1172 10.1029 31.4005 9.59862 31.9048C9.09434 32.4091 8.81103 33.093 8.81103 33.8062H7.81104C7.81104 32.8278 8.1997 31.8895 8.89152 31.1977C9.58334 30.5058 10.5216 30.1172 11.5 30.1172C12.4784 30.1172 13.4167 30.5058 14.1085 31.1977C14.8004 31.8895 15.189 32.8278 15.189 33.8062Z"
				></path>
			</symbol>
			<symbol id="price" viewBox="0 0 267 288">
				<path
					fill="none"
					strokeWidth="10"
					d="M266.3 282.9H154.7L121.9 250.1V223.8H73.8"
				></path>
				<path
					fill="none"
					strokeWidth="10"
					d="M261.9 97H156.9L121.9 132V162.6H91.3"
				></path>
				<path
					fill="none"
					strokeWidth="10"
					d="M91.3 127.6H5.5V5.69995H196.3V75.1"
				></path>
				<path fill="none" strokeWidth="10" d="M36.1001 40.1H161.3"></path>
				<path fill="none" strokeWidth="10" d="M36.1001 66.3H161.3"></path>
				<path fill="none" strokeWidth="10" d="M36.1001 92.6H91.3"></path>
				<path fill="none" strokeWidth="10" d="M82.5 184.5H244.4"></path>
				<path fill="none" strokeWidth="10" d="M78.1001 202H231.3"></path>
			</symbol>
			<symbol id="features" viewBox="0 0 65 65">
				<path
					d="M48.2329 35.5944H44.3719L37.8141 29.0367H16.7671V16.1089H44.6709V17.5533H18.2115V27.5922H38.4135L44.9699 34.15H46.7884V14.5243H16.7671V8.22656H47.5106V9.67101H18.2115V13.0799H48.2329V35.5944Z"
					fill="#192E50"
				></path>
				<path
					d="M21.6796 56.0551H20.2351V50.3336L27.6654 42.9034V32.5655H23.9546L20.9256 35.5945H17.4893V34.1501H20.3261L23.3551 31.1211H29.1098V43.5014L21.6796 50.9331V56.0551Z"
					fill="#192E50"
				></path>
				<path
					d="M44.8716 56.0555H43.4271V50.9335L36.1862 43.6911V31.8438H37.6306V43.0931L44.8716 50.3341V56.0555Z"
					fill="#192E50"
				></path>
				<path
					d="M32.5 26.0574C31.7732 26.0577 31.0626 25.8423 30.4583 25.4386C29.8539 25.0349 29.3829 24.461 29.1048 23.7895C28.8267 23.118 28.7541 22.3791 28.8961 21.6663C29.0382 20.9535 29.3885 20.2989 29.9027 19.7853C30.4169 19.2716 31.072 18.9221 31.7849 18.7809C32.4979 18.6397 33.2367 18.7132 33.9079 18.9921C34.5791 19.2709 35.1524 19.7426 35.5554 20.3475C35.9584 20.9523 36.1729 21.6631 36.1718 22.3899C36.1695 23.3627 35.7818 24.2948 35.0935 24.9822C34.4053 25.6696 33.4727 26.0562 32.5 26.0574ZM32.5 20.1568C32.0593 20.1565 31.6284 20.2869 31.2618 20.5314C30.8952 20.776 30.6093 21.1237 30.4403 21.5307C30.2712 21.9377 30.2266 22.3856 30.3121 22.8179C30.3976 23.2503 30.6093 23.6475 30.9205 23.9596C31.2317 24.2716 31.6285 24.4843 32.0605 24.5709C32.4926 24.6575 32.9407 24.6141 33.3481 24.4461C33.7555 24.2781 34.104 23.9931 34.3495 23.6272C34.595 23.2612 34.7265 22.8306 34.7273 22.3899C34.7277 22.0971 34.6704 21.807 34.5587 21.5363C34.4469 21.2655 34.283 21.0195 34.0761 20.8121C33.8693 20.6047 33.6237 20.4401 33.3532 20.3277C33.0828 20.2153 32.7929 20.1572 32.5 20.1568V20.1568Z"
					fill="#192E50"
				></path>
				<path
					d="M37.8285 56.0551H36.384C36.384 55.025 35.9748 54.037 35.2464 53.3086C34.518 52.5802 33.5301 52.171 32.4999 52.171C31.4698 52.171 30.4819 52.5802 29.7535 53.3086C29.025 54.037 28.6158 55.025 28.6158 56.0551H27.1714C27.1714 54.6419 27.7328 53.2866 28.7321 52.2873C29.7314 51.288 31.0867 50.7266 32.4999 50.7266C33.9132 50.7266 35.2685 51.288 36.2678 52.2873C37.2671 53.2866 37.8285 54.6419 37.8285 56.0551V56.0551Z"
					fill="#192E50"
				></path>
			</symbol>
			<symbol id="horizon-hand" viewBox="0 0 335 333">
				<path
					fill="none"
					strokeWidth="10px"
					d="M272.3,328.9l-17.9,-27.9l-80.3,-2.3l-74.1,-26.4l-91.3,-23.9l17.1,-21.4l102.2,22.5"
				></path>
				<path
					fill="none"
					strokeWidth="10px"
					d="M233.8,267l-105.8,-17.5l17,-29.3l72.7,9.1l40.7,-18.1l57.7,26.2l14.4,43.2"
				></path>
				<path fill="none" strokeWidth="10px" d="M42.8,209.9l83.1,18.8"></path>
				<rect
					fill="none"
					strokeWidth="10px"
					x="221.9"
					y="5"
					width="21.9"
					height="21.9"
				></rect>
				<path
					strokeWidth="0"
					d="M121.4,5l-22.1,0l0,172l22.1,0l0,-77.4l100.5,0l0,77.4l21.9,0l0,-97.5l-122.4,0.2l0,-74.7Z"
				></path>
			</symbol>
			<symbol id="heart" viewBox="0 0 40 37">
				<path
					strokeWidth="1"
					d="M19.6857 36.6333L0.791016 20.1013V5.52267L5.84835 0.46534H15.7337L20.1243 4.85601L24.515 0.46534H34.407L39.411 5.64667V19.8933L31.6537 28.4147L30.6684 27.516L38.0777 19.3773V6.18534L33.8417 1.79867H25.067L20.1243 6.74134L15.1817 1.79867H6.40035L2.12435 6.07467V19.496L20.563 35.6307L19.6857 36.6333Z"
				></path>
				<path
					strokeWidth="1"
					d="M21.846 31.784L7.38867 19.1333L8.26734 18.1307L21.81 29.98L32.8273 19.512V8.13201H34.1607V20.0853L21.846 31.784Z"
				></path>
			</symbol>
			<symbol id="star" viewBox="0 0 48 46">
				<path
					strokeWidth="1"
					d="M28.1241 31.0189L27.3574 29.9282L42.9041 19.0189H31.4734V17.6855H47.1241L28.1241 31.0189Z"
				></path>
				<path
					strokeWidth="1"
					d="M29.4471 22.9616L23.8751 4.80424L19.9311 16.9429L18.6631 16.5309L23.9111 0.378906L30.7218 22.5696L29.4471 22.9616Z"
				></path>
				<path
					strokeWidth="1"
					d="M14.0187 27.0901L0.277344 17.1074L23.488 17.4888L23.4653 18.8221L4.47601 18.5101L14.8013 26.0114L14.0187 27.0901Z"
				></path>
				<path
					strokeWidth="1"
					d="M8.88574 44.7529L16.4204 22.7969L17.6804 23.2302L11.5164 41.1929L21.8417 33.6915L22.6257 34.7702L8.88574 44.7529Z"
				></path>
				<path
					strokeWidth="1"
					d="M37.8375 45.111L19.2842 31.1603L20.0868 30.095L35.2655 41.5083L31.3215 29.3696L32.5895 28.959L37.8375 45.111Z"
				></path>
			</symbol>
			<symbol id="family" viewBox="0 0 46 43">
				<path
					strokeWidth="1"
					d="M8.04405 9.87617C7.07492 9.87617 6.12755 9.58879 5.32175 9.05037C4.51595 8.51195 3.8879 7.74667 3.51704 6.85132C3.14617 5.95596 3.04913 4.97073 3.2382 4.02023C3.42726 3.06972 3.89394 2.19663 4.57922 1.51135C5.2645 0.826073 6.1376 0.359394 7.0881 0.170326C8.03861 -0.0187413 9.02384 0.0782949 9.91919 0.449164C10.8146 0.820033 11.5798 1.44808 12.1182 2.25388C12.6567 3.05968 12.944 4.00704 12.944 4.97617C12.9426 6.2753 12.4259 7.52081 11.5073 8.43943C10.5887 9.35805 9.34317 9.87475 8.04405 9.87617ZM8.04405 0.742841C7.20677 0.742841 6.3883 0.991121 5.69213 1.45628C4.99596 1.92145 4.45337 2.58261 4.13296 3.35614C3.81254 4.12968 3.72871 4.98087 3.89205 5.80205C4.0554 6.62324 4.45858 7.37755 5.05063 7.96959C5.64267 8.56163 6.39698 8.96481 7.21816 9.12816C8.03935 9.2915 8.89053 9.20767 9.66407 8.88726C10.4376 8.56684 11.0988 8.02425 11.5639 7.32808C12.0291 6.63191 12.2774 5.81344 12.2774 4.97617C12.276 3.85385 11.8295 2.77791 11.0359 1.98431C10.2423 1.19072 9.16636 0.744252 8.04405 0.742841Z"
				></path>
				<path
					strokeWidth="1"
					d="M38.3333 12.6398C37.3642 12.6398 36.4169 12.3525 35.6111 11.814C34.8053 11.2756 34.1772 10.5104 33.8063 9.615C33.4355 8.71964 33.3384 7.73441 33.5275 6.7839C33.7166 5.8334 34.1832 4.9603 34.8685 4.27502C35.5538 3.58975 36.4269 3.12307 37.3774 2.934C38.3279 2.74493 39.3131 2.84197 40.2085 3.21284C41.1039 3.58371 41.8691 4.21175 42.4075 5.01755C42.946 5.82335 43.2333 6.77072 43.2333 7.73985C43.2323 9.03908 42.7157 10.2848 41.797 11.2035C40.8783 12.1222 39.6326 12.6388 38.3333 12.6398ZM38.3333 3.50651C37.4961 3.50651 36.6776 3.75479 35.9814 4.21996C35.2853 4.68512 34.7427 5.34628 34.4223 6.11982C34.1019 6.89336 34.018 7.74454 34.1814 8.56573C34.3447 9.38691 34.7479 10.1412 35.3399 10.7333C35.932 11.3253 36.6863 11.7285 37.5075 11.8918C38.3286 12.0552 39.1798 11.9713 39.9534 11.6509C40.7269 11.3305 41.3881 10.7879 41.8532 10.0918C42.3184 9.39559 42.5667 8.57712 42.5667 7.73985C42.5656 6.61742 42.1193 5.54127 41.3256 4.7476C40.5319 3.95392 39.4558 3.50757 38.3333 3.50651Z"
				></path>
				<path
					strokeWidth="1"
					d="M23.1335 22.4333C22.1641 22.4346 21.216 22.1483 20.4094 21.6107C19.6027 21.0731 18.9736 20.3083 18.6017 19.4131C18.2298 18.5178 18.1318 17.5324 18.3201 16.5814C18.5085 15.6305 18.9746 14.7568 19.6596 14.0708C20.3446 13.3849 21.2177 12.9176 22.1684 12.7279C23.1191 12.5383 24.1047 12.635 25.0004 13.0057C25.8962 13.3763 26.6618 14.0044 27.2005 14.8103C27.7393 15.6163 28.0268 16.5639 28.0268 17.5333C28.0254 18.8313 27.5096 20.0758 26.5924 20.9942C25.6753 21.9126 24.4314 22.4301 23.1335 22.4333ZM23.1335 13.3C22.2959 13.2986 21.4768 13.5458 20.7797 14.0102C20.0827 14.4745 19.5391 15.1352 19.2176 15.9086C18.8962 16.6821 18.8114 17.5335 18.974 18.3551C19.1366 19.1767 19.5393 19.9316 20.131 20.5243C20.7228 21.1171 21.4771 21.5209 22.2985 21.6848C23.1198 21.8487 23.9714 21.7652 24.7453 21.445C25.5192 21.1248 26.1808 20.5822 26.6462 19.8859C27.1117 19.1896 27.3601 18.3709 27.3601 17.5333C27.3587 16.4121 26.9132 15.3372 26.121 14.5438C25.3289 13.7504 24.2546 13.3031 23.1335 13.3Z"
				></path>
				<path
					strokeWidth="1"
					d="M32.8935 24.5375H14.8228L12.3975 22.1135V17.5335H13.0641V21.8375L15.0988 23.8708H32.2268V17.2148L35.0695 14.4375H45.7801V15.1042H35.3401L32.8935 17.4948V24.5375Z"
				></path>
				<path
					strokeWidth="1"
					d="M16.1374 21.3868H15.4707V17.4362L12.9547 12.5202H0.713379V11.8535H13.3627L16.1374 17.2762V21.3868Z"
				></path>
				<path
					strokeWidth="1"
					d="M14.5067 41.9094H8.11067V31.0281H3.46134V41.5761H2.79468V30.3614H8.77734V41.2427H13.84V29.7334H14.5067V41.9094Z"
				></path>
				<path
					strokeWidth="1"
					d="M27.5266 42.0839H18.8879V29.7332H19.5546V41.4172H26.8599V29.3999H30.8786V30.0666H27.5266V42.0839Z"
				></path>
				<path
					strokeWidth="1"
					d="M36.648 42.6759H35.9814V35.6545H29.332L35.0027 26.8892V20.4985H35.6694V27.0852L35.616 27.1679L30.5574 34.9879H36.648V42.6759Z"
				></path>
			</symbol>
			<symbol id="car-size" viewBox="0 0 31 29">
				<path
					strokeWidth="0"
					d="M2.91022 6.58266L0.303223 5.93066L2.87822 3.35566L6.31122 4.21466L8.88922 0.347656H22.0882L25.3012 4.47766L24.5122 5.09166L21.5992 1.34766H9.42422L6.75222 5.35566L3.18522 4.46366L2.25922 5.38866L3.15322 5.61266L2.91022 6.58266Z"
				></path>
				<path
					strokeWidth="0"
					d="M5.71937 19.7225H1.65637V9.39045L3.73237 7.31445L10.4854 8.35545L8.52237 10.9725H3.90637V9.97245H8.02237L8.68437 9.08945L4.08137 8.38045L2.65637 9.80445V18.7225H4.71937V15.2225H13.9694V16.2225H5.71937V19.7225Z"
				></path>
				<path
					strokeWidth="0"
					d="M28.844 10.9721H22.469L20.5 8.34606L24.398 7.78906L24.539 8.77906L22.313 9.09706L22.969 9.97206H28.844V10.9721Z"
				></path>
				<path
					strokeWidth="0"
					d="M29.3441 19.7229H25.2811V16.2229H15.1061L19.1561 12.4429V10.0979H12.2191V9.09789H20.1561V12.8769L17.6441 15.2229H26.2811V18.7229H28.3441V9.82789L24.7851 6.77789L28.7931 5.44189L27.8341 4.48189L26.8141 4.82189L26.4981 3.87289L28.1041 3.33789L30.6441 5.87889L26.7771 7.16789L29.3441 9.36789V19.7229Z"
				></path>
				<path
					strokeWidth="0"
					d="M29.3445 28.6523H1.75647V22.6523H2.75647V27.6523H28.3445V22.6523H29.3445V28.6523Z"
				></path>
				<path
					strokeWidth="0"
					d="M14.2341 22.6523H13.2341V25.8993H14.2341V22.6523Z"
				></path>
				<path
					strokeWidth="0"
					d="M10.2893 22.6523H9.28931V25.8993H10.2893V22.6523Z"
				></path>
				<path
					strokeWidth="0"
					d="M6.34412 22.6523H5.34412V25.8993H6.34412V22.6523Z"
				></path>
				<path
					strokeWidth="0"
					d="M18.1802 22.6523H17.1802V25.8993H18.1802V22.6523Z"
				></path>
				<path
					strokeWidth="0"
					d="M22.125 22.6523H21.125V25.8993H22.125V22.6523Z"
				></path>
				<path
					strokeWidth="0"
					d="M26.0703 22.6523H25.0703V25.8993H26.0703V22.6523Z"
				></path>
			</symbol>
			<symbol id="close" viewBox="0 0 25 24">
				<path
					strokeWidth="0"
					d="M11.5199 13.0387L0.157227 1.67607L1.09989 0.733398L11.5199 11.1534L21.9399 0.733398L22.8826 1.67607L11.5199 13.0387Z"
				></path>
				<path
					strokeWidth="0"
					d="M21.9398 23.4002L12.5771 14.0376L23.8745 2.74023L24.8172 3.6829L14.4625 14.0376L22.8825 22.4576L21.9398 23.4002Z"
				></path>
				<path
					strokeWidth="0"
					d="M9.0489 13.5673L0.158203 22.458L1.10101 23.4008L9.99171 14.5101L9.0489 13.5673Z"
				></path>
			</symbol>
			<symbol id="service" viewBox="0 0 90 88">
				<path d="M70.8579 87.4637L43.1419 59.8893L23.8702 65.0517L0.331482 41.513L4.84682 24.6621L24.2659 44.0813L39.5713 39.9819L43.6735 24.6766L24.2515 5.25459L41.1024 0.739258L64.6439 24.2808L59.4815 43.5468L89.8119 73.8801L87.7695 75.9226L56.2575 44.4106L61.4199 25.1446L40.2415 3.96326L29.8328 6.75104L46.8946 23.8128L41.9315 42.3393L23.4021 47.3024L6.34037 30.2435L3.55259 40.6493L24.7339 61.8306L43.9999 56.6682L72.8946 85.4155L70.8579 87.4637Z"></path>
				<path d="M80.9662 87.4637L46.1551 52.6526L26.7273 57.5088L26.0253 54.7066L47.042 49.4517L83.0086 85.4183L80.9662 87.4637Z"></path>
			</symbol>
			<symbol id="heart-add" viewBox="0 0 49 47">
				<path
					strokeWidth="1"
					d="M24.1518 46.0674L0.535156 25.4024V7.17909L6.85516 0.857422H19.2135L24.7018 6.34576L30.1885 0.857422H42.5552L48.8085 7.33409V24.8191H47.1418V8.00742L41.8468 2.52409H30.8802L24.7018 8.70242L18.5218 2.52409H7.54682L2.20182 7.86909V24.6458L25.2502 44.8141L24.1518 46.0674Z"
				></path>
				<path
					strokeWidth="1"
					d="M31.5017 29.5017H16.7617V27.8351H29.8351V14.7617H31.5017V29.5017Z"
				></path>
				<path
					strokeWidth="1"
					d="M35.7433 41.794H34.0767V32.209H48.8167V33.8757H35.7433V41.794Z"
				></path>
				<path
					strokeWidth="1"
					d="M46.0333 29.5026H34.0767V20.7227H35.7433V27.836H46.0333V29.5026Z"
				></path>
				<path
					strokeWidth="1"
					d="M31.555 46.169H29.8884V33.8757H19.5967V32.209H31.555V46.169Z"
				></path>
			</symbol>
			<symbol id="fuel" viewBox="0 0 34 31">
				<path
					strokeWidth="0"
					d="M2.37997 19.3064L1.42297 19.0174L5.42097 5.80137H14.363L19.681 0.484375H32.847V1.48438H20.095L14.777 6.80137H6.16297L2.37997 19.3064Z"
				></path>
				<path
					strokeWidth="0"
					d="M4.5732 30.5172C3.53457 30.5162 2.53872 30.1034 1.80392 29.3693C1.06912 28.6353 0.655315 27.6399 0.653198 26.6012C0.653198 24.6282 3.7892 19.4832 4.1472 18.9012L4.2932 18.6632H6.0002L8.8102 9.57422H14.4402L16.5222 11.6572H20.8072L28.5482 19.4012H32.8482V20.4012H28.1332L20.3932 12.6612H16.1082L14.0262 10.5782H9.5502L6.7402 19.6672H4.8532C3.8402 21.3422 1.6532 25.2402 1.6532 26.6032C1.66736 27.3682 1.98117 28.097 2.52714 28.633C3.07311 29.1689 3.80762 29.4692 4.5727 29.4692C5.33777 29.4692 6.07229 29.1689 6.61826 28.633C7.16423 28.097 7.47804 27.3682 7.4922 26.6032C7.4922 25.6712 6.2212 23.1752 5.4202 21.8202L6.2812 21.3112C6.5072 21.6942 8.4922 25.0932 8.4922 26.6032C8.48982 27.6414 8.076 28.6363 7.34142 29.37C6.60683 30.1036 5.61139 30.5162 4.5732 30.5172V30.5172Z"
				></path>
				<path
					strokeWidth="0"
					d="M27.8421 16.5947L22.8921 11.6447V7.76172H33.3471V12.0187H28.1191V11.0187H32.3471V8.76172H23.8921V11.2307L28.5491 15.8877L27.8421 16.5947Z"
				></path>
			</symbol>
			<symbol id="speedometer" viewBox="0 0 35 27">
				<path
					strokeWidth="0"
					d="M17.5 20.8543C16.8869 20.8543 16.2876 20.6725 15.7778 20.3318C15.268 19.9912 14.8706 19.5071 14.636 18.9406C14.4014 18.3742 14.34 17.7509 14.4596 17.1495C14.5792 16.5482 14.8745 15.9958 15.308 15.5623C15.7415 15.1287 16.2939 14.8335 16.8952 14.7139C17.4966 14.5942 18.1199 14.6556 18.6864 14.8903C19.2528 15.1249 19.737 15.5222 20.0776 16.032C20.4182 16.5418 20.6 17.1412 20.6 17.7543C20.5982 18.5759 20.271 19.3633 19.69 19.9443C19.1091 20.5252 18.3216 20.8524 17.5 20.8543V20.8543ZM17.5 15.6463C17.0847 15.6463 16.6787 15.7695 16.3333 16.0002C15.988 16.231 15.7188 16.5589 15.5599 16.9427C15.4009 17.3264 15.3593 17.7486 15.4404 18.156C15.5214 18.5633 15.7214 18.9375 16.0151 19.2312C16.3088 19.5249 16.683 19.7249 17.0903 19.8059C17.4977 19.887 17.9199 19.8454 18.3037 19.6864C18.6874 19.5275 19.0154 19.2583 19.2461 18.913C19.4769 18.5677 19.6 18.1616 19.6 17.7463C19.5982 17.1899 19.3763 16.6568 18.9829 16.2634C18.5895 15.87 18.0564 15.6481 17.5 15.6463V15.6463Z"
				></path>
				<path
					strokeWidth="0"
					d="M4.10001 24.2684C0.500014 16.8784 3.59101 7.94141 10.982 4.34742C18.373 0.753421 27.309 3.84142 30.9 11.2324L31.081 11.6034L21.788 18.5624L19.388 13.6304L26.712 11.3054L27.012 12.2584L20.8 14.2334L22.163 17.0334L29.818 11.3004C26.352 4.67242 18.19 1.95242 11.418 5.24542C4.52401 8.60041 1.64301 16.9364 5.00001 23.8314L4.10001 24.2684Z"
				></path>
				<path
					strokeWidth="0"
					d="M17.5 26.251H2.772L2.629 25.994C1.23205 23.4709 0.499437 20.634 0.5 17.75C0.5 8.375 8.127 0.75 17.5 0.75C26.873 0.75 34.5 8.376 34.5 17.75C34.4998 20.6341 33.7669 23.4708 32.37 25.994L31.5 25.508C32.8133 23.1333 33.5015 20.4637 33.5 17.75C33.5 8.927 26.322 1.75 17.5 1.75C8.678 1.75 1.5 8.927 1.5 17.75C1.50008 20.3648 2.14039 22.9397 3.365 25.25H17.5V26.251Z"
				></path>
			</symbol>
			<symbol id="camera" viewBox="0 0 34 36">
				<path
					strokeWidth="1"
					d="M5.33333 31.707H0V11.707H30.4173V13.0404H1.33333V30.3737H5.33333V31.707Z"
				></path>
				<path
					strokeWidth="1"
					d="M24.0837 10.125H9.91699V0.625H24.0837V10.125ZM11.2503 8.79167H22.7503V1.95833H11.2503V8.79167Z"
				></path>
				<path
					strokeWidth="1"
					d="M17.5838 31.1243C15.8098 31.1255 14.0904 30.5114 12.7184 29.3868C11.3465 28.2622 10.4071 26.6967 10.0602 24.957C9.71324 23.2173 9.98035 21.4111 10.816 19.8463C11.6516 18.2815 13.004 17.0549 14.6427 16.3755C16.2814 15.6961 18.105 15.6061 19.8027 16.1206C21.5004 16.6352 22.9671 17.7226 23.9528 19.1974C24.9386 20.6723 25.3824 22.4433 25.2086 24.2087C25.0348 25.9742 24.2542 27.6247 22.9998 28.879C22.2901 29.5925 21.4461 30.1583 20.5165 30.5437C19.5869 30.9291 18.5901 31.1264 17.5838 31.1243V31.1243ZM17.5838 17.1243C16.1187 17.1254 14.6993 17.6344 13.5674 18.5646C12.4355 19.4947 11.6611 20.7885 11.3761 22.2256C11.0911 23.6627 11.3131 25.1541 12.0044 26.4459C12.6956 27.7376 13.8133 28.7498 15.1671 29.3099C16.5209 29.87 18.027 29.9434 19.4288 29.5177C20.8307 29.092 22.0416 28.1934 22.8552 26.975C23.6689 25.7567 24.035 24.2939 23.8912 22.8359C23.7473 21.3779 23.1025 20.0149 22.0664 18.979C21.4792 18.3886 20.7805 17.9207 20.011 17.6023C19.2415 17.2839 18.4165 17.1215 17.5838 17.1243V17.1243Z"
				></path>
				<path
					strokeWidth="1"
					d="M28.6664 19.4577C28.1883 19.4577 27.7209 19.3159 27.3234 19.0503C26.9258 18.7847 26.616 18.4072 26.433 17.9655C26.2501 17.5237 26.2022 17.0377 26.2955 16.5688C26.3887 16.0999 26.619 15.6691 26.957 15.3311C27.2951 14.993 27.7258 14.7628 28.1948 14.6695C28.6637 14.5762 29.1497 14.6241 29.5914 14.8071C30.0331 14.99 30.4107 15.2999 30.6763 15.6974C30.9419 16.0949 31.0837 16.5623 31.0837 17.0404C31.0833 17.6814 30.8286 18.296 30.3753 18.7493C29.922 19.2026 29.3074 19.4574 28.6664 19.4577ZM28.6664 15.9577C28.4519 15.9577 28.2423 16.0213 28.064 16.1405C27.8857 16.2597 27.7468 16.429 27.6648 16.6272C27.5827 16.8253 27.5614 17.0434 27.6033 17.2537C27.6452 17.464 27.7486 17.6571 27.9003 17.8087C28.0521 17.9602 28.2453 18.0634 28.4557 18.105C28.6661 18.1467 28.8841 18.1251 29.0821 18.0428C29.2802 17.9606 29.4494 17.8214 29.5683 17.643C29.6873 17.4645 29.7506 17.2548 29.7504 17.0404C29.75 16.7531 29.6356 16.4777 29.4324 16.2747C29.2291 16.0717 28.9536 15.9577 28.6664 15.9577V15.9577Z"
				></path>
				<path
					strokeWidth="1"
					d="M34.0003 35.2077H0.666992V33.8744H32.667V9.54102H28.0003V6.54102H29.3337V8.20768H34.0003V35.2077Z"
				></path>
			</symbol>
			<symbol id="location" viewBox="0 0 27 41">
				<path
					strokeWidth="1"
					d="M14.2 40.6436L13.0774 39.9249C13.2 39.7329 25.4134 20.5823 25.4134 13.985C25.4134 10.8621 24.1728 7.86718 21.9646 5.65901C19.7565 3.45083 16.7615 2.21029 13.6387 2.21029C10.5159 2.21029 7.52093 3.45083 5.31276 5.65901C3.10458 7.86718 1.86404 10.8621 1.86404 13.985C1.86404 18.7436 8.28537 30.133 11.656 35.781L20.428 19.0676L21.608 19.6876L11.7414 38.4943L11.1334 37.4863C7.17737 30.9436 0.540039 19.1903 0.540039 13.985C0.540039 10.5085 1.92106 7.17442 4.37928 4.7162C6.83751 2.25797 10.1716 0.876953 13.648 0.876953C17.1245 0.876953 20.4586 2.25797 22.9168 4.7162C25.375 7.17442 26.756 10.5085 26.756 13.985C26.7507 20.9703 14.716 39.8436 14.2 40.6436Z"
				></path>
				<path
					strokeWidth="1"
					d="M13.6428 19.9509C12.6494 19.9511 11.6783 19.6568 10.8523 19.105C10.0263 18.5532 9.38249 17.7689 9.00235 16.8511C8.62221 15.9334 8.52281 14.9235 8.71673 13.9493C8.91066 12.975 9.38918 12.0802 10.0918 11.378C10.7944 10.6758 11.6895 10.1977 12.6638 10.0043C13.6381 9.81089 14.648 9.91083 15.5655 10.2915C16.483 10.6721 17.2671 11.3163 17.8184 12.1426C18.3697 12.9689 18.6636 13.9402 18.6628 14.9335C18.6603 16.2639 18.1306 17.5391 17.1896 18.4795C16.2486 19.42 14.9732 19.9491 13.6428 19.9509V19.9509ZM13.6428 11.2429C12.9134 11.2426 12.2004 11.4586 11.5938 11.8636C10.9872 12.2685 10.5142 12.8443 10.2348 13.518C9.9554 14.1917 9.88202 14.9332 10.024 15.6486C10.1659 16.364 10.5168 17.0213 11.0322 17.5373C11.5477 18.0533 12.2046 18.4049 12.9198 18.5476C13.6351 18.6903 14.3766 18.6177 15.0506 18.339C15.7247 18.0603 16.3009 17.5881 16.7065 16.9819C17.1122 16.3757 17.3289 15.6629 17.3295 14.9335C17.3291 13.9555 16.9407 13.0176 16.2495 12.3256C15.5583 11.6337 14.6208 11.2443 13.6428 11.2429V11.2429Z"
				></path>
			</symbol>
			<symbol id="question" viewBox="0 0 60 61">
				<path
					strokeWidth="1"
					d="M33.8305 51.8813H19.7132V27.7253H27.1158C28.0338 27.7253 28.9312 27.4531 29.6944 26.9431C30.4577 26.4331 31.0526 25.7083 31.4039 24.8602C31.7552 24.0121 31.8471 23.0789 31.668 22.1785C31.4889 21.2782 31.0468 20.4512 30.3977 19.8021C29.7486 19.153 28.9216 18.7109 28.0213 18.5318C27.121 18.3528 26.1878 18.4447 25.3397 18.796C24.4916 19.1473 23.7667 19.7421 23.2567 20.5054C22.7467 21.2687 22.4745 22.166 22.4745 23.084V23.7507H14.4932V23.084C14.4932 20.6159 15.2168 18.2019 16.5745 16.1408C17.9322 14.0796 19.8643 12.4617 22.1319 11.4872C24.3995 10.5127 26.903 10.2243 29.3328 10.6578C31.7625 11.0913 34.0119 12.2276 35.8026 13.9261C37.5933 15.6247 38.8468 17.8109 39.4079 20.2144C39.9691 22.6179 39.8133 25.1331 38.9598 27.449C38.1064 29.7649 36.5928 31.7797 34.6062 33.2443C32.6196 34.7089 30.2472 35.559 27.7825 35.6893V40.2333H33.4065L49.2732 11.796H39.5532L38.5185 14.2867L37.2878 13.7747L38.6665 10.4627H51.5438L34.1892 41.5667H26.4492V34.3733H27.1158C29.3203 34.3734 31.4765 33.7281 33.3184 32.5169C35.1604 31.3058 36.6074 29.582 37.4811 27.558C38.3547 25.5341 38.6167 23.2987 38.2346 21.1276C37.8526 18.9565 36.8433 16.9448 35.3313 15.3406C33.8193 13.7365 31.8707 12.6101 29.726 12.1005C27.5813 11.5909 25.3343 11.7203 23.2623 12.4728C21.1902 13.2254 19.3839 14.5681 18.0661 16.3352C16.7483 18.1024 15.9767 20.2167 15.8465 22.4173H21.1798C21.3085 21.2713 21.7661 20.187 22.4974 19.2953C23.2287 18.4035 24.2025 17.7425 25.3012 17.392C26.3999 17.0415 27.5765 17.0164 28.6891 17.3198C29.8017 17.6233 30.8028 18.2422 31.5714 19.102C32.34 19.9617 32.8434 21.0256 33.0208 22.1651C33.1981 23.3046 33.0419 24.4711 32.571 25.5238C32.1 26.5765 31.3345 27.4704 30.3668 28.0977C29.399 28.7249 28.2704 29.0587 27.1172 29.0587H21.0465V50.548H32.4972V44.744H26.5465V43.4107H33.8305V51.8813Z"
				></path>
			</symbol>
			<symbol id="support" viewBox="0 0 359 329">
				<path
					fill="none"
					strokeWidth="var(--strokeWidth, 14)"
					d="M279.9 115.1C270.5 68.1001 228.9 32.7 179.2 32.7C122.5 32.7 76.3999 78.7 76.3999 135.5"
				></path>
				<path
					fill="none"
					strokeWidth="var(--strokeWidth, 14)"
					d="M86.8 234.8L135.5 323.6H227.7L282 216.6V138.9H313"
				></path>
				<path
					fill="none"
					strokeWidth="var(--strokeWidth, 14)"
					d="M76.4 135.4V219.7H45.4C23.1 219.7 5 201.6 5 179.3C5 157 23.1 138.9 45.4 138.9C45.4 64.9999 105.3 5.1001 179.2 5.1001C253.1 5.1001 313 64.9999 313 138.9C335.4 138.9 353.6 157.1 353.6 179.5C353.6 201.9 335.4 220.1 313 220.1H305.4L269.7 288.5H199.8"
				></path>
				<path
					fill="none"
					strokeWidth="var(--strokeWidth, 14)"
					d="M200 276.9H161.7V300.6H200V276.9Z"
				></path>
			</symbol>
			<symbol id="user" viewBox="0 0 512 512">
				<path
					strokeWidth="0"
					d="M255.999,0c-74.443,0-135,60.557-135,135s60.557,135,135,135s135-60.557,135-135S330.442,0,255.999,0z"
				></path>
				<path
					strokeWidth="0"
					d="M478.48,398.68C438.124,338.138,370.579,302,297.835,302h-83.672c-72.744,0-140.288,36.138-180.644,96.68l-2.52,3.779V512 h450h0.001V402.459L478.48,398.68z"
				></path>
			</symbol>
			<symbol id="download" viewBox="0 0 24 24">
				<path d="M13 12H16L12 16L8 12H11V8H13V12ZM15 4H5V20H19V8H15V4ZM3 2.9918C3 2.44405 3.44749 2 3.9985 2H16L20.9997 7L21 20.9925C21 21.5489 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5447 3 21.0082V2.9918Z"></path>
			</symbol>
			<symbol id="unlock" viewBox="0 0 30 41">
				<path
					strokeWidth="1"
					d="M24.4277 40.6965H8.05706V39.3632H23.8757L28.2091 35.0298V18.4378L1.98372 18.7218V31.4898L6.45439 35.9592H19.7624V37.2925H5.90106L0.650391 32.0418V17.4032L29.5424 17.0898V35.5832L24.4277 40.6965Z"
				></path>
				<path
					strokeWidth="1"
					d="M26.7241 17.7646H25.3908V12.4312C25.36 9.72138 24.2618 7.13299 22.3347 5.22765C20.4075 3.32231 17.8068 2.25371 15.0968 2.25371C12.3868 2.25371 9.78605 3.32231 7.85891 5.22765C5.93176 7.13299 4.83364 9.72138 4.8028 12.4312H3.4668C3.49959 9.36903 4.73905 6.44339 6.91603 4.28959C9.09302 2.13579 12.0318 0.927734 15.0941 0.927734C18.1565 0.927734 21.0952 2.13579 23.2722 4.28959C25.4492 6.44339 26.6887 9.36903 26.7215 12.4312L26.7241 17.7646Z"
				></path>
				<path
					strokeWidth="1"
					d="M15.764 23.3887H14.4307V30.9407H15.764V23.3887Z"
				></path>
			</symbol>
			<symbol id="security" viewBox="0 0 74 89">
				<path
					strokeWidth="0"
					d="M37.0001 88.4488L5.28586 60.7154L0.0454102 8.29076L37.0001 0.372314L73.9548 8.29076L68.7143 60.701L37.0001 88.4488ZM8.04763 59.271L37.0001 84.6094L65.9525 59.2768L70.8232 10.5759L37.0001 3.32765L3.17697 10.5759L8.04763 59.271Z"
				></path>
				<path
					strokeWidth="0"
					d="M37.9361 78.2567L36.0641 76.0554L58.7997 56.7316L63.2254 16.8996L38.4446 11.7372V55.1427H35.5557V8.18384L66.3859 14.6058L61.5441 58.1905L37.9361 78.2567Z"
				></path>
			</symbol>
			<symbol id="envelope-sent" viewBox="0 0 46 42">
				<path
					strokeWidth="1"
					d="M20.185 29.234L5.80371 19.2994L6.56104 18.2034L19.9917 27.4794L44.8064 0.636719L45.7851 1.54205L20.185 29.234Z"
				></path>
				<path
					strokeWidth="1"
					d="M39.3493 41.4899H0.682617V14.3539H32.616V15.6873H2.01595V40.1566H38.016V19.0286L38.116 15.1473L20.1573 33.9833L13.512 28.8873L14.3239 27.8286L20.0186 32.1966L39.5386 11.7246L39.3493 19.0539V41.4899Z"
				></path>
			</symbol>
			<symbol id="check" viewBox="0 0 42 37">
				<path
					strokeWidth="1"
					d="M14.6093 33.1091L7.63867 28.0384L8.42267 26.9597L14.2853 31.2237L35.4814 0.289062L36.5814 1.04373L14.6093 33.1091Z"
				></path>
				<path
					strokeWidth="1"
					d="M40.1483 0.293019L16.2295 35.291L17.3303 36.0433L41.2491 1.04535L40.1483 0.293019Z"
				></path>
				<path
					strokeWidth="1"
					d="M13.5663 27.4187L0.625 17.5294L1.43567 16.4707L13.2277 25.4814L18.553 17.2214L19.6743 17.944L13.5663 27.4187Z"
				></path>
			</symbol>
			<symbol id="green" viewBox="0 0 42 38">
				<path
					strokeWidth="1"
					d="M22.7777 34.8338H21.4443V20.6364L28.391 11.1631L41.775 7.14844L40.2576 16.8991L31.4777 24.5604H23.0577L33.7683 12.5098L34.7656 13.3964L26.027 23.2271H30.9777L39.015 16.2138L40.1323 9.03377L29.203 12.3111L22.7777 21.0724V34.8338Z"
				></path>
				<path
					strokeWidth="1"
					d="M20.3468 37.2638H19.0135V19.0998L16.6708 7.97451L2.3548 2.46784L5.15747 15.5612L12.0401 22.0078L16.1335 21.9758L13.6361 11.0038L6.66013 8.09718L7.17213 6.86651L14.7828 10.0385L17.8015 23.2972L11.5175 23.3465L3.94013 16.2492L0.536133 0.339844L17.8268 6.99051L20.3468 18.9612V37.2638Z"
				></path>
			</symbol>
			<symbol id="building" viewBox="0 0 41 43">
				<path
					strokeWidth="1"
					d="M1.06535 42.7065H0.398682V14.3105H22.268V14.9772H1.06535V42.7065Z"
				></path>
				<path
					strokeWidth="1"
					d="M25.2934 18.5574H7.09473V17.8908H24.6267V0.412109H40.8681V1.07878H25.2934V18.5574Z"
				></path>
				<path
					strokeWidth="1"
					d="M32.3681 13.6415H28.5427V6.06152H32.3681V13.6415ZM29.2094 12.9749H31.7014V6.72819H29.2094V12.9749Z"
				></path>
				<path
					strokeWidth="1"
					d="M38.8774 13.6415H35.0508V6.06152H38.8774V13.6415ZM35.7174 12.9749H38.2108V6.72819H35.7174V12.9749Z"
				></path>
				<path
					strokeWidth="1"
					d="M32.3681 24.4321H28.5427V16.8521H32.3681V24.4321ZM29.2094 23.7654H31.7014V17.5187H29.2094V23.7654Z"
				></path>
				<path
					strokeWidth="1"
					d="M38.8774 24.4321H35.0508V16.8521H38.8774V24.4321ZM35.7174 23.7654H38.2108V17.5187H35.7174V23.7654Z"
				></path>
				<path
					strokeWidth="1"
					d="M32.3681 35.2226H28.5427V27.6426H32.3681V35.2226ZM29.2094 34.5559H31.7014V28.3092H29.2094V34.5559Z"
				></path>
				<path
					strokeWidth="1"
					d="M38.8774 35.2226H35.0508V27.6426H38.8774V35.2226ZM35.7174 34.5559H38.2108V28.3092H35.7174V34.5559Z"
				></path>
				<path
					strokeWidth="1"
					d="M11.7971 31.5281H4.21582V23.9468H11.7971V31.5281ZM4.88249 30.8615H11.1305V24.6134H4.88249V30.8615Z"
				></path>
				<path
					strokeWidth="1"
					d="M22.3906 31.5281H14.8105V23.9468H22.3906V31.5281ZM15.4772 30.8615H21.7239V24.6134H15.4772V30.8615Z"
				></path>
				<path
					strokeWidth="1"
					d="M11.7971 41.1429H4.21582V33.5615H11.7971V41.1429ZM4.88249 40.4762H11.1305V34.2282H4.88249V40.4762Z"
				></path>
				<path
					strokeWidth="1"
					d="M22.3906 41.1429H14.8105V33.5615H22.3906V41.1429ZM15.4772 40.4762H21.7239V34.2282H15.4772V40.4762Z"
				></path>
			</symbol>
			<symbol id="pc" viewBox="0 0 43 50">
				<path
					strokeWidth="1"
					d="M42.668 49.3067H1.26937V48.6401H42.0014V25.9548H1.6027V45.2734H26.8054V38.5948H19.144V41.9561H18.4774V37.9281H27.472V45.9401H0.936035V25.2881H42.668V49.3067Z"
				></path>
				<path
					strokeWidth="1"
					d="M11.8735 23.5429H11.2068V16.2749H15.8881V16.9416H11.8735V23.5429Z"
				></path>
				<path
					strokeWidth="1"
					d="M29.2667 23.5428H28.6V20.0094H26.7107V19.3428H29.2667V23.5428Z"
				></path>
				<path
					strokeWidth="1"
					d="M27.0439 21.9425H16.8492L15.0985 14.7771L15.7452 14.6185L17.3719 21.2758H26.3772V8.11979H17.3532L13.8879 12.1771V16.5545H13.2212V11.9305L17.0452 7.45312H27.0439V21.9425Z"
				></path>
				<path
					strokeWidth="1"
					d="M31.844 25.6216H31.1774V16.9416H26.7107V16.2749H31.844V25.6216Z"
				></path>
				<path
					strokeWidth="1"
					d="M14.6879 21.2988H14.0212V19.3428H16.6386V20.0094H14.6879V21.2988Z"
				></path>
				<path
					strokeWidth="1"
					d="M28.4054 5.80926H15.0134L15.1641 0.489258L15.8294 0.507925L15.6988 5.14259H27.7574L27.8894 0.489258L28.5548 0.507925L28.4054 5.80926Z"
				></path>
			</symbol>
			<symbol id="list" viewBox="0 0 30 32">
				<path
					strokeWidth="0"
					d="M6.81602 10.8741L2.61902 7.5731L3.23702 6.78709L6.70802 9.51709L15.048 0.496094L15.782 1.17409L6.81602 10.8741Z"
				></path>
				<path
					strokeWidth="0"
					d="M13.645 15.9133H0.769043V3.23828H12.731V4.23828H1.76904V14.9133H12.645V7.92528L12.661 7.29628L6.81404 13.4293L4.34004 11.5313L4.94804 10.7373L6.71004 12.0893L13.728 4.72828L13.645 7.94428V15.9133Z"
				></path>
				<path
					strokeWidth="0"
					d="M6.81602 26.6221L2.61902 23.3211L3.23702 22.5351L6.70802 25.2651L15.048 16.2441L15.782 16.9231L6.81602 26.6221Z"
				></path>
				<path
					strokeWidth="0"
					d="M13.645 31.6633H0.769043V18.9883H12.731V19.9883H1.76904V30.6633H12.645V23.6743L12.661 23.0463L6.81404 29.1783L4.34004 27.2813L4.94804 26.4873L6.71004 27.8383L13.728 20.4783L13.645 23.6943V31.6633Z"
				></path>
				<path
					strokeWidth="0"
					d="M29.7311 3.23828H17.2931V4.23828H29.7311V3.23828Z"
				></path>
				<path
					strokeWidth="0"
					d="M29.7311 8.72266H17.2931V9.72266H29.7311V8.72266Z"
				></path>
				<path
					strokeWidth="0"
					d="M29.7311 14.209H17.2931V15.209H29.7311V14.209Z"
				></path>
				<path
					strokeWidth="0"
					d="M29.7311 19.6934H17.2931V20.6934H29.7311V19.6934Z"
				></path>
				<path
					strokeWidth="0"
					d="M29.7311 25.1777H17.2931V26.1777H29.7311V25.1777Z"
				></path>
				<path
					strokeWidth="0"
					d="M29.7311 30.6641H17.2931V31.6641H29.7311V30.6641Z"
				></path>
			</symbol>
			<symbol id="more" viewBox="0 0 10 35">
				<path
					strokeWidth="0"
					d="M9.04838 9.2H0.831055V0.978668H9.04838V9.2ZM2.16439 7.86667H7.71505V2.312H2.16439V7.86667Z"
				></path>
				<path
					strokeWidth="0"
					d="M9.04838 22.0293H0.831055V13.812H9.04838V22.0293ZM2.16439 20.696H7.71505V15.1453H2.16439V20.696Z"
				></path>
				<path
					strokeWidth="0"
					d="M9.04838 34.8627H0.831055V26.6453H9.04838V34.8627ZM2.16439 33.5293H7.71505V27.9787H2.16439V33.5293Z"
				></path>
			</symbol>
			<symbol id="grid-add" viewBox="0 0 35 36">
				<path
					fill="none"
					strokeWidth="1px"
					d="M33.64 1.5332H20.7556V14.4177H33.64V1.5332Z"
				></path>
				<path
					fill="none"
					strokeWidth="1px"
					d="M13.9955 1.5332H1.11108V14.4177H13.9955V1.5332Z"
				></path>
				<path
					fill="none"
					strokeWidth="1px"
					d="M13.9955 21.8125H1.11108V34.6969H13.9955V21.8125Z"
				></path>
				<path fill="none" strokeWidth="1px" d="M27.1978 21.0762V34.6973"></path>
				<path fill="none" strokeWidth="1px" d="M20.7556 28.2559H33.64"></path>
			</symbol>
			<symbol id="car-question" viewBox="0 0 42 43">
				<path
					strokeWidth="1"
					d="M4.25103 25.4305L0.776367 24.5612L4.20837 21.1292L8.7857 22.2732L12.223 17.1172H19.667V18.4505H12.9364L9.3737 23.7945L4.6177 22.6052L3.38437 23.8385L4.57503 24.1372L4.25103 25.4305Z"
				></path>
				<path
					strokeWidth="1"
					d="M33.0531 23.4425L29.1704 18.4505H21.8438V17.1172H29.8224L34.1051 22.6239L33.0531 23.4425Z"
				></path>
				<path
					strokeWidth="1"
					d="M7.99608 42.9503H2.58008V29.1743L5.34675 26.4062L14.3508 27.7943L11.7334 31.2836H5.58008V29.9503H11.0667L11.9494 28.7729L5.81208 27.8276L3.91341 29.7263V41.6169H6.66275V36.9503H18.9961V38.2836H7.99608V42.9503Z"
				></path>
				<path
					strokeWidth="1"
					d="M38.8294 31.2831H30.3294L27.7041 27.7817L32.9014 27.0391L33.0908 28.3591L30.1214 28.7831L30.9961 29.9497H38.8294V31.2831Z"
				></path>
				<path
					strokeWidth="1"
					d="M39.4954 42.9502H34.0794V38.2835H20.5128L25.9128 33.2435V30.1169H16.6621V28.7835H27.2461V33.8235L23.8954 36.9502H35.4128V41.6169H38.1621V29.7568L33.4181 25.6902L38.7621 23.9089L37.4821 22.6288L36.1234 23.0822L35.7021 21.8168L37.8421 21.1035L41.2301 24.4915L36.0741 26.2102L39.4954 29.1435V42.9502Z"
				></path>
				<path
					strokeWidth="1"
					d="M16.1624 5.04093H14.8291V3.3436L17.3504 0.822266H21.0478V2.1556H17.9038L16.1624 3.8956V5.04093Z"
				></path>
				<path
					strokeWidth="1"
					d="M22.4132 19.3343H21.0799V13.6236L25.9332 8.77027V3.8956L24.1919 2.1556H21.0479V0.822266H24.7452L27.2665 3.3436V9.32227L22.4132 14.1756V19.3343Z"
				></path>
				<path
					strokeWidth="1"
					d="M22.5111 20.9766H21.1777V22.7592H22.5111V20.9766Z"
				></path>
			</symbol>
			<symbol id="envelope" viewBox="0 0 40 36">
				<path
					strokeWidth="1"
					d="M39.3493 35.0027H0.682617V13.5587L20.016 0.872017L39.3493 13.5587V35.0027ZM2.01595 33.6693H38.016V14.2787L20.016 2.46668L2.01595 14.2787V33.6693Z"
				></path>
				<path
					strokeWidth="1"
					d="M35.849 31.2094H4.84902V29.876H34.5157V16.056L20.0157 21.6334L4.61035 15.708L5.08902 14.4627L20.0157 20.204L35.849 14.1147V31.2094Z"
				></path>
			</symbol>
			<symbol id="message" viewBox="0 0 283 287">
				<path
					fill="none"
					strokeWidth="var(--strokeWidth, 14)"
					d="M207.1 84.0001V5.30005H5.80005V140.9H23.3V189L50.3999 140.9H75.8"
				></path>
				<path
					fill="none"
					strokeWidth="var(--strokeWidth, 14)"
					d="M277.1 84H75.8V219.6H232.5L259.6 267.8V219.6H277.1V84Z"
				></path>
				<path
					fill="none"
					strokeWidth="var(--strokeWidth, 14)"
					d="M93.3 140.9H207.1V97.1001"
				></path>
				<path
					fill="none"
					strokeWidth="var(--strokeWidth, 14)"
					d="M93.3 167.1H211.4"
				></path>
				<path
					fill="none"
					strokeWidth="var(--strokeWidth, 14)"
					d="M93.3 193.4H211.4"
				></path>
			</symbol>
			<symbol id="hybrid" viewBox="0 0 251 370">
				<path
					fill="none"
					strokeWidth="10"
					d="M157.8 84C146.3 63.2 135 44.1 126.4 29.8L47.7 179.7H120.6L40.8999 339.8L238.8 123H151L198.5 50.3"
				></path>
				<path
					fill="none"
					strokeWidth="10"
					d="M72.6001 323.5C84.2001 327.9 96.7999 330.3 109.9 330.3C167.9 330.3 214.9 283.3 214.9 225.3C214.9 214.7 211.4 200.6 205.7 184.6"
				></path>
				<path
					fill="none"
					strokeWidth="10"
					d="M110 3.30005C110 3.30005 5 167.3 5 225.3C5 256.9 19.0001 285.3 41.1001 304.5"
				></path>
			</symbol>
			<symbol id="testdrive" viewBox="0 0 65 53">
				<path
					fill="none"
					strokeWidth="2"
					strokeMiterlimit="10"
					d="M32.8564 32.6129C36.5432 32.6129 39.5319 29.6241 39.5319 25.9373C39.5319 22.2505 36.5432 19.2617 32.8564 19.2617C29.1695 19.2617 26.1808 22.2505 26.1808 25.9373C26.1808 29.6241 29.1695 32.6129 32.8564 32.6129Z"
				></path>
				<path
					fill="none"
					strokeWidth="2"
					strokeMiterlimit="10"
					d="M57.6291 22.0954L55.7342 24.3728L55.0388 26.7196L57.0901 32.3522C57.6291 30.3008 57.9246 28.1452 57.9246 25.9373C57.9246 24.6335 57.8377 23.3471 57.6291 22.0954ZM46.6769 5.02399C42.7133 2.39896 37.9674 0.869141 32.8564 0.869141C26.598 0.869141 20.8612 3.16387 16.463 6.97104L19.5921 10.1176L21.0872 9.26577C24.4076 6.91889 28.4755 5.52814 32.8564 5.52814C37.6545 5.52814 42.0701 7.17965 45.5469 9.96114L48.85 6.65812L46.6769 5.02399ZM40.1404 45.0253V32.8389L42.3482 30.6311H46.4857L46.1033 25.9373L40.0187 20.2179V17.2799L37.3415 14.6028H28.3712L24.9639 18.0101V20.2005L18.8794 25.92L18.4969 30.6137H23.3645L25.5724 32.8215V45.0079C22.5649 43.8606 19.8877 42.0178 17.7494 39.671L17.2626 45.5642C21.5392 48.9542 26.9457 50.9882 32.8216 50.9882C38.3846 50.9882 43.5304 49.1628 47.7026 46.1032L47.2332 40.3837C45.2688 42.4003 42.835 43.9823 40.1404 45.0253ZM7.9968 22.8603C7.87511 23.8686 7.80557 24.8943 7.80557 25.9373C7.80557 27.7279 7.9968 29.4664 8.34449 31.1353L9.94384 26.7196L9.24847 24.3728L7.9968 22.8603Z"
				></path>
				<path
					fill="none"
					strokeWidth="2"
					strokeMiterlimit="10"
					d="M48.2763 52.7091L46.1032 25.9373L40.0187 20.2004V14.6201L42.1048 13.3336V8.20524L45.3905 10.1175L48.8673 6.64065L46.6595 5.00652L54.2739 1.91211L56.7077 4.29376L56.2731 6.0322L58.6895 7.99662L58.9155 9.54383L58.1332 10.9172L60.2541 12.7425L60.4627 13.9073L60.1498 14.9504L61.245 16.1673L60.8973 18.1491L55.7515 24.3727L55.0562 26.7195L64.1829 51.8399"
				></path>
				<path
					fill="none"
					strokeWidth="2"
					strokeMiterlimit="10"
					d="M16.7237 52.7091L18.8968 25.9373L24.9813 20.2004V14.6201L22.8952 13.3336V8.20524L19.6095 10.1175L16.1327 6.64065L18.3405 5.00652L10.7261 1.91211L8.29234 4.29376L8.72695 6.0322L6.31053 7.99662L6.08453 9.54383L6.84944 10.9172L4.72855 12.7425L4.53732 13.9073L4.85024 14.9504L3.75503 16.1673L4.10272 18.1491L9.24848 24.3727L9.94385 26.7195L0.817078 51.8399"
				></path>
			</symbol>
			<symbol id="shipping" viewBox="0 0 60 60">
				<path
					fill="none"
					strokeWidth="2"
					d="M42.5351 7.15479L37.9899 0.951172H19.1828L15.2997 7.15479L10.1103 5.78466L7.51566 8.54394L10.1103 9.229"
				></path>
				<path
					fill="none"
					strokeWidth="2"
					d="M11.3987 16.1177H17.8765L19.827 13.3584L11.3987 11.9883L8.80405 14.7476V29.9141H13.3492V24.3955H26.3227"
				></path>
				<path
					fill="none"
					strokeWidth="2"
					d="M41.8908 12.6738L37.3456 13.3589L39.2961 16.1182H48.3686"
				></path>
				<path
					fill="none"
					strokeWidth="2"
					d="M23.728 14.7471H34.751V19.5615L29.8837 24.395H43.8235V29.9136H48.3686V14.7471L43.8235 10.5986L49.657 8.54346L47.0624 5.78418L45.1298 6.46924"
				></path>
				<path
					fill="none"
					strokeWidth="2"
					d="M48.7265 59.4858L45.5234 54.1765L31.1542 53.7389L17.8944 48.7151L1.55679 44.148L4.61674 40.0947L22.9048 44.3764"
				></path>
				<path
					fill="none"
					strokeWidth="2"
					d="M41.8371 47.7068L22.9048 44.3767L25.9469 38.782L38.9561 40.5327L46.2392 37.0693L56.5643 42.0551L59.1411 50.2948"
				></path>
				<path
					fill="none"
					strokeWidth="2"
					d="M7.65881 36.8223L22.5291 40.3998"
				></path>
			</symbol>
			<symbol id="settings" viewBox="0 0 39 33">
				<path
					strokeWidth="0"
					d="M15.7958 27.2578H0.198486V28.5911H15.7958V27.2578Z"
				></path>
				<path
					strokeWidth="0"
					d="M38.3266 27.2578H22.7292V28.5911H38.3266V27.2578Z"
				></path>
				<path
					strokeWidth="0"
					d="M20.6108 32.549H15.9094V23.293H20.6108V32.549ZM17.2428 31.2156H19.2774V24.6263H17.2428V31.2156Z"
				></path>
				<path
					strokeWidth="0"
					d="M21.7385 15.7422H0.198486V17.0755H21.7385V15.7422Z"
				></path>
				<path
					strokeWidth="0"
					d="M38.3269 15.7422H28.6709V17.0755H38.3269V15.7422Z"
				></path>
				<path
					strokeWidth="0"
					d="M26.5518 21.0372H21.8518V11.7812H26.5518V21.0372ZM23.1851 19.7039H25.2185V13.1146H23.1851V19.7039Z"
				></path>
				<path
					strokeWidth="0"
					d="M11.8345 4.23047H0.198486V5.5638H11.8345V4.23047Z"
				></path>
				<path
					strokeWidth="0"
					d="M38.327 4.23047H18.7683V5.5638H38.327V4.23047Z"
				></path>
				<path
					strokeWidth="0"
					d="M16.6496 9.52429H11.9482V0.265625H16.6496V9.52429ZM13.2816 8.19096H15.3162V1.59896H13.2816V8.19096Z"
				></path>
			</symbol>
			<symbol id="offer" viewBox="0 0 65 65">
				<path d="M15.3659 35.0608L11.6017 34.119L15.3197 30.401L20.2785 31.6404L24.0022 26.0547H43.0689L47.7085 32.0202L46.5688 32.9071L42.3626 27.4991H24.775L20.9155 33.2885L15.7631 32L14.427 33.3361L15.7169 33.6597L15.3659 35.0608Z"></path>
				<path d="M19.4234 54.0398H13.556V39.1159L16.5533 36.1172L26.3076 37.6209L23.4721 41.401H16.806V39.9565H22.7499L23.7061 38.6811L17.0574 37.657L15.0005 39.7139V52.5954H17.9789V47.5398H31.34V48.9843H19.4234V54.0398Z"></path>
				<path d="M52.8261 41.4023H43.6178L40.7737 37.6092L46.4041 36.8047L46.6092 38.2347L43.3925 38.694L44.34 39.9579H52.8261V41.4023Z"></path>
				<path d="M53.5485 54.0383H47.6812V48.9828H32.9839L38.8339 43.5228V40.1355H28.8124V38.6911H40.2784V44.1511L36.6485 47.5383H49.1256V52.5939H52.104V39.7455L46.9647 35.34L52.754 33.4102L51.3674 32.0235L49.8955 32.5146L49.439 31.1439L51.7574 30.3711L55.4277 34.0414L49.842 35.9033L53.5485 39.0811V54.0383Z"></path>
				<path d="M28.2706 16.0318H26.8262V13.8376L30.0935 10.5703H37.6595V12.0148H30.6915L28.2706 14.4356V16.0318Z"></path>
				<path d="M38.2922 23.7052H29.7772L26.8262 20.7541V18.5586H28.2706V20.1561L30.3752 22.2607H38.2922V23.7052Z"></path>
				<path d="M36.3956 15.3086H25.0206V16.753H36.3956V15.3086Z"></path>
				<path d="M36.3956 17.8359H25.0206V19.2804H36.3956V17.8359Z"></path>
			</symbol>

			<symbol id="arrow-right" viewBox="0 0 75 75">
				<path
					strokeWidth="0"
					d="M57.162,35.843l-36.039,36.039l3.121,3.118l36.039,-36.039l-3.121,-3.118Z"
				></path>
				<path
					strokeWidth="0"
					d="M17.838,68.364l-3.121,-3.122l34.268,-34.262l-27.862,-27.862l3.121,-3.118l30.98,30.98l-37.386,37.384Z"
				></path>
			</symbol>

			<symbol id="orders-and-delivery" viewBox="0 0 6000 6000">
				  <g transform="rotate(180, 3000, 3000)">

				<g fill="#000000" stroke="none">
					<path d="M3443 5818 c-57 -19 -90 -60 -204 -258 -62 -107 -146 -253 -187 -325 -41 -71 -99 -170 -127 -220 -29 -49 -330 -571 -670 -1160 -339 -588 -684 -1185 -765 -1325 -80 -140 -181 -313 -222 -385 -605 -1044 -1039 -1805 -1044 -1832 -12 -61 4 -121 44 -165 56 -62 79 -68 260 -68 l158 0 75 112 c404 612 936 1159 1469 1512 261 173 494 294 730 379 69 24 132 47 140 50 49 18 -34 3 -152 -27 -432 -111 -818 -287 -1193 -544 -214 -146 -441 -343 -595 -514 -51 -57 -102 -112 -113 -123 -19 -20 -19 -20 -4 5 13 22 655 1133 782 1355 29 50 195 338 370 640 175 303 342 591 370 640 29 50 229 396 445 770 216 374 416 719 443 768 27 48 52 87 57 87 5 0 25 -30 46 -67 20 -38 99 -174 174 -303 76 -129 203 -347 282 -485 173 -298 542 -935 716 -1235 334 -574 419 -722 467 -805 28 -49 118 -204 198 -342 81 -139 213 -367 293 -505 81 -139 170 -293 199 -343 29 -49 75 -129 103 -178 28 -48 48 -87 43 -87 -26 0 -1118 637 -1481 865 -238 149 -498 335 -587 420 -111 107 18 -76 142 -200 332 -334 1144 -957 2178 -1673 l248 -172 59 0 c74 0 105 12 153 58 58 57 73 141 38 217 -10 22 -263 463 -561 980 -299 517 -609 1055 -690 1195 -81 140 -426 737 -765 1325 -340 589 -641 1111 -670 1160 -28 50 -86 149 -127 220 -41 72 -125 218 -187 325 -62 107 -126 207 -142 221 -51 45 -127 59 -196 37z" fill="#FFF" />
					<path d="M3792 2159 c-41 -23 -63 -29 -95 -27 l-42 3 40 22 40 22 -35 1 c-65 0 -334 -49 -459 -85 -342 -98 -675 -277 -991 -533 -151 -122 -426 -403 -561 -572 -215 -269 -407 -567 -553 -857 l-26 -53 1086 0 1086 0 -7 150 c-4 82 -4 246 0 365 l7 215 178 0 177 0 6 -67 c4 -38 21 -202 38 -365 l32 -298 1169 0 1169 0 -173 142 c-899 737 -1618 1405 -1882 1747 -59 77 -116 178 -116 206 0 23 -30 18 -88 -16z m-96 -111 c-25 -42 -27 -43 -86 -46 -33 -2 -60 0 -60 3 0 4 12 24 28 46 26 37 29 39 85 39 l58 0 -25 -42z m-60 -130 c-3 -18 -11 -49 -17 -70 l-10 -38 -79 0 c-90 0 -87 -7 -40 93 l22 47 65 0 66 0 -7 -32z m-38 -270 l-3 -93 -107 -3 c-101 -2 -108 -1 -108 17 0 18 37 147 47 164 2 4 42 7 89 7 l85 0 -3 -92z m4 -328 c3 -69 9 -155 12 -192 l6 -68 -160 0 c-121 0 -160 3 -160 13 1 36 48 356 54 366 5 8 45 11 124 9 l117 -3 7 -125z" fill="#FFF" />
				</g>
				</g>
			</symbol>
		</svg>
	);
};
